import { PrinterFilled } from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Divider,
  Layout,
  Modal,
  Row,
  Select,
  Table,
  Typography,
} from "antd";
import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import toastr from "toastr";

import { ReactComponent as AverageMarksIcon } from "../../../assets/images/icons/average-marks.svg";
import { ReactComponent as ExamFailedIcon } from "../../../assets/images/icons/exam-failed.svg";
import { ReactComponent as ExamPassedIcon } from "../../../assets/images/icons/exam-passed.svg";
import { ReactComponent as HighestMarksIcon } from "../../../assets/images/icons/highest-marks.svg";
import { ReactComponent as LiveExamIcon } from "../../../assets/images/icons/live-exam.svg";
import { ReactComponent as LowestMarksIcon } from "../../../assets/images/icons/lowest-marks.svg";

import ScoreSummaryCard from "../../Header/student/ScoreSummaryCard.component";
import SecondaryHeaderComponent from "../../Header/student/secondaryHeader.component";
import StudentHeader from "../../Header/student/studentHeader.component";
import "./StudentScoreboard.page.style.css";

import {
  getExamResultRequest,
  getStudentProfile,
  setStatesToInitial,
} from "../../../stateManager/reducers/studentAuthSlice";
import PrintQuestion from "./PrintQuestion";
import MeritList from "./MeritList";
import { instance } from "../../../constants/constString";

const { Header, Content } = Layout;
const { Title } = Typography;

const StudentScoreboard = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const studentProfile = useSelector(
    (state) => state.studentAuth.studentProfile
  );
  const [isLoading, setIsLoading] = useState(false);
  const [startPrinting, setStartPrinting] = useState(false);
  const [examForMeritList, setExamForMeritList] = useState();
  const [isMeritListModalOpen, setIsMeritListModalOpen] = useState(false);
  const handleOpenMeritListModal = (isOpen, exam) => {
    setIsMeritListModalOpen(isOpen);
    setExamForMeritList(exam);
  };
  const columns = [
    {
      title: "Exam Name",
      dataIndex: "examId",
      key: "ExamName",
      
      render: (text, record, index) =>
        record?.examId ? (
          <Button
          style={{maxWidth:320, minWidth:200, textWrap:"wrap", textAlign:"left", padding:0}}
            type="link"
            onClick={() =>
              record?.groupId
                ? fetchResult({
                    examId: record?.examId?._id,
                    groupId: record?.groupId,
                  })
                : toastr.error(
                    "You cannot view the details of this exam!",
                    "Info is missing!"
                  )
            }
          >
            {record?.examId?.title}
          </Button>
        ) : (
          "N/A"
        ),
    },
    {
      title: "Exam Date",
      dataIndex: "startsAt",
      key: "ExamDate",
      render: (text) => (
        <span className="table-center-text">
          {moment(text).format("MMM DD, YYYY")}
        </span>
      ),
    },
    {
      title: "Exam Type",
      render: (_, Obj) => (
        <span className="table-center-text">
         {Obj?.isPracticeExam?"Practice" : "Live"}
        </span>
      ),
    },
    {
      title: "Pass/Fail",
      key: "PassFail",
      render: (text, record, index) => (
        <span
          className={
            (record?.marksObtained * 100) / record?.examId?.totalMarks >=
            record?.examId?.passMark
              ? "table-center-text is-success"
              : "table-center-text is-error"
          }
        >
          {(record?.marksObtained * 100) / record?.examId?.totalMarks >=
          record?.examId?.passMark
            ? "PASS"
            : "FAIL"}
        </span>
      ),
    },
    {
      title: "Merit Position",
      dataIndex: "rank",
      key: "MeritPosition",
      render: (text) => <span className="table-center-text">{text}</span>,
    },
    {
      title: "Obtained Marks",
      dataIndex: "marksObtained",
      key: "ObtainedMarks",
      render: (text) => (
        <span className="table-center-text">{text?.toFixed(2)}</span>
      ),
    },
    {
      title: "Total Marks",
      dataIndex: "examId",
      key: "TotalMarks",
      render: (text, record, index) => (
        <span className="table-center-text">
          {record?.gpaFactor
            ? text?.totalMarks +
              record?.gpaFactor?.hsc * 5 +
              record?.gpaFactor?.ssc * 5
            : text?.totalMarks}
        </span>
      ),
    },
    {
      title: "Negative Marks",
      dataIndex: "negativeMarks",
      key: "NegativeMarks",
      render: (text) => (
        <span className="table-center-text">{text?.toFixed(2)}</span>
      ),
    },
    {
      title: "Course",
      dataIndex: "",
      render: (_, Obj) => <div style={{maxWidth:300}}>{Obj?.examId?.courseName}</div>,
    },
    {
      title: "Action",
      dataIndex: "",
      render: (_, Obj) => {
        return (
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
             <Button
              style={{ borderRadius: 10 }}
              type="primary"
              onClick={() => handleOpenMeritListModal(true, Obj?.examId)}
            >
              Merit List
            </Button>
            
          </div>
        );
      },
    },
  ];

  const [newScoreBoard, setNewScoreBoard] = useState(null);
  const fetchAndSetNewScoreBoard = async () => {
    const response = await instance.get(`/exam/newScoreBoard`);
    setNewScoreBoard(response?.data?.data?.results?.examResult ?? []);
  };

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      try {
        dispatch(setStatesToInitial("scoreboardExamResult"));
        await Promise.all([
          fetchAndSetNewScoreBoard(),
          dispatch(getStudentProfile()),
        ]);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    }
    fetchData();
    // eslint-disable-next-line
  }, []);

  async function fetchResult({ examId, groupId }) {
    const res = await dispatch(getExamResultRequest({ examId, groupId }));
    if (res.payload?.status === "200" && !!!res?.payload?.data.code) {
      history.push(`/result/${examId}/${groupId}`);
    }
  }

  const [selectedCourse, setSelectedCourse] = useState();
  const examResult = useMemo(() => {
    return newScoreBoard?.filter((i) =>
      selectedCourse ? i?.examId?.courseId === selectedCourse : true
    );
  }, [newScoreBoard, selectedCourse]);

  const courses = useMemo(() => {
    const uniqueCoursesMap = new Map();
    newScoreBoard?.forEach((item) => {
      if (
        item?.examId?.courseId &&
        !uniqueCoursesMap.has(item?.examId?.courseId)
      ) {
        uniqueCoursesMap.set(item?.examId?.courseId, {
          label: item?.examId?.courseName,
          value: item?.examId?.courseId,
        });
      }
    });
    return Array.from(uniqueCoursesMap.values());
  }, [newScoreBoard]);

  const examSummary = useMemo(() => {
    if (!newScoreBoard?.length) return null;

    if (!newScoreBoard?.length) return null;

    let totalMarksObtained = 0;
    let totalMarks = 0;
    let passCount = 0;
    let failCount = 0;
    let maxMarkObtained = -Infinity;
    let minMarkObtained = Infinity;

    newScoreBoard.forEach((exam) => {
      const marksObtained = exam.marksObtained || 0;
      const examTotalMarks = exam.examId?.totalMarks || 0;
      const passMark = exam.examId?.passMark || 0;

      totalMarksObtained += marksObtained;
      totalMarks += examTotalMarks;

      if ((marksObtained * 100) / examTotalMarks >= passMark) {
        passCount += 1;
      } else {
        failCount += 1;
      }

      if (marksObtained > maxMarkObtained) maxMarkObtained = marksObtained;
      if (marksObtained < minMarkObtained) minMarkObtained = marksObtained;
    });

    const averageMarkObtained =
      newScoreBoard.length > 0 ? totalMarksObtained / newScoreBoard.length : 0;

    return {
      count: newScoreBoard.length,
      totalMarksObtained,
      totalMarks,
      passCount,
      failCount,
      maxMarkObtained,
      minMarkObtained,
      averageMarkObtained,
    };
  }, [newScoreBoard]);

  const summary = [
    {
      title: "Exams",
      value: examSummary?.count || "0",
      icon: <LiveExamIcon />,
    },
    {
      title: "Exam Passed",
      value: examSummary?.passCount || "0",
      icon: <ExamPassedIcon />,
    },
    {
      title: "Exam Failed",
      value: examSummary?.failCount || "0",
      icon: <ExamFailedIcon />,
    },
    {
      title: "Highest Marks",
      value: examSummary?.maxMarkObtained
        ? examSummary?.maxMarkObtained.toFixed(2)
        : "0",
      icon: <HighestMarksIcon />,
    },
    {
      title: "Lowest Marks",
      value: examSummary?.minMarkObtained
        ? examSummary?.minMarkObtained.toFixed(2)
        : "0",
      icon: <LowestMarksIcon />,
    },
    {
      title: "Average Marks",
      value: examSummary?.averageMarkObtained
        ? examSummary?.averageMarkObtained.toFixed(2)
        : 0,
      icon: <AverageMarksIcon />,
    },
  ];

  return (
    <Layout>
      <Header>
        <StudentHeader />
      </Header>
      <Layout>
        <SecondaryHeaderComponent />
      </Layout>
      <Layout>
        <Button
          size="large"
          type="primary"
          icon={<PrinterFilled />}
          style={{ margin: "10px", marginLeft: "auto", width: "100px" }}
          onClick={async () => {
            setStartPrinting(true);
            setTimeout(() => {
              window.print();
            }, 1000);

            setTimeout(() => {
              setStartPrinting(false);
            }, 2000);
          }}
        >
          Print
        </Button>

        <Content className="custom-container sec-mh" style={{ paddingTop: 15 }}>
          {studentProfile ? (
            <Row style={{ marginBottom: 30 }}>
              <Col xs={24}>
                <Card style={{ width: "100%", borderRadius: 10 }}>
                  <Row>
                    <Col xs={24} md={24}>
                      <div className="score-user">
                        <div className="user-info">
                          <Title level={3} style={{ marginBottom: 0 }}>
                            {studentProfile?.name}
                          </Title>
                          <ul className="avatar-group-list">
                            {studentProfile?.groups &&
                              studentProfile?.groups.map((item, index) => (
                                <li key={index + ""}>{item?.name}</li>
                              ))}
                          </ul>
                        </div>
                      </div>
                    </Col>
                    <Divider style={{ marginTop: 0, marginBottom: 15 }} />
                    {examSummary ? (
                      <Col xs={24} md={24}>
                        <Title level={4} className="score-total-marks">
                          Total Marks Obtained:{" "}
                          {`${
                            examSummary?.totalMarksObtained
                              ? examSummary?.totalMarksObtained?.toFixed(2)
                              : "0"
                          }/${examSummary?.totalMarks ?? 0}`}
                        </Title>
                      </Col>
                    ) : (
                      <></>
                    )}
                    {summary ? (
                      <Row gutter={[10, 10]}>
                        {summary.map((summaryData) => (
                          <Col xs={12} md={12} lg={8}>
                            <ScoreSummaryCard summaryData={summaryData} />
                          </Col>
                        ))}
                      </Row>
                    ) : (
                      <></>
                    )}
                    <Col xs={24} md={24}></Col>
                  </Row>
                </Card>
              </Col>
            </Row>
          ) : (
            <></>
          )}

          {courses?.length ? (
            <div
              style={{
                padding: 10,
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Select
                allowClear
                options={courses}
                size="large"
                style={{ width: "300px" }}
                placeholder={"Select Course"}
                value={selectedCourse}
                onChange={setSelectedCourse}
              />
            </div>
          ) : (
            <></>
          )}
          <Row>
            <Col xs={24}>
              <Table
                loading={isLoading}
                pagination={false}
                columns={columns}
                dataSource={examResult}
                className="students-scoreboard-table"
              />
            </Col>
          </Row>
        </Content>
      </Layout>
      {startPrinting && (
        <Row className="print-teacher">
          <PrintQuestion
            liveExam={examSummary}
            studentProfile={studentProfile}
            examResult={newScoreBoard}
          />
        </Row>
      )}
      <Modal
        open={isMeritListModalOpen}
        onCancel={() => handleOpenMeritListModal(false, null)}
        width={1000}
        footer={false}
      >
        <MeritList exam={examForMeritList} />
      </Modal>
    </Layout>
  );
};

export default StudentScoreboard;
